import Airbrake from 'airbrake-js';

const config = {
  projectId: 126864,
  projectKey: '48259e2306f6964fcc45f67ec9f02db2',
};
const airbrake = new Airbrake(config);

let stateGetter = null;

export function setStateGetter(getState) {
  stateGetter = getState;
}

function generateContext() {
  if (!stateGetter) {
    return {};
  }
  return stateGetter()
    .update(state =>
      state
        .update('account', account => account.get('authUser'))
        .update(s => s.set('authUser', s.get('account')))
        .updateIn(['authUser', 'organisations'], orgs => orgs.get(0))
        .updateIn(
          ['authUser'],
          authUser => authUser.set('organisation', authUser.get('organisations')),
        )
        .deleteIn(['authUser', 'organisations'])
        .update('device', device => device.delete('developer').delete('hash')))
    .filter((v, k) => ['device', 'authUser', 'currentUser'].includes(k))
    .toJS();
}

airbrake.addFilter((notice) => {
  if (__DEV__) {
    console.log('[AIRBRAKE]', notice);
    return null;
  }
  if (
    notice.errors.length > 0
    && notice.errors[0].message === 'only one instance of babel-polyfill is allowed'
  ) {
    return null; // ignore the babel-polyfill error
  }
  return {
    ...notice,
    context: {
      ...notice.context,
      environment: process.env.BRANCH_SLUG,
      version: process.env.LOG_VERSION,
      kiosk: !!window.KIOSK_MODE,
      ...generateContext(),
    },
  };
});

export default airbrake;



// WEBPACK FOOTER //
// ./src/lib/Airbrake.js